import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { SwatchSelectorMinimal } from 'dibs-swatch-selector/exports/SwatchSelectorMinimal';

// styles
import styles from './PdpSharedCondensedSkuAttributes.scss';

export const PdpSharedCondensedSkuAttributesComponent = ({ item, selectedSkuId }) => {
    if (!item.isMultiSku) {
        return null;
    }
    const skus = item.skus || [];
    const selectedSku = skus.find(sku => sku.serviceId === selectedSkuId);
    const variableAttributeRows = selectedSku?.variableAttributeRows || [];
    const isRingItem = item?.isRingItem;

    return isRingItem ? null : (
        <div className={styles.skuInfoContainer}>
            {variableAttributeRows.map(({ label, value }) => (
                <div key={`${label}-${value}`} className={styles.attribute}>
                    <span className={styles.attributeLabel}>{label}: </span>
                    {value}
                </div>
            ))}
            <SwatchSelectorMinimal item={item} containerClassName={styles.swatchesContainer} />
        </div>
    );
};

PdpSharedCondensedSkuAttributesComponent.propTypes = {
    item: PropTypes.object.isRequired,
    selectedSkuId: PropTypes.string,
};

export const PdpSharedCondensedSkuAttributes = createFragmentContainer(
    PdpSharedCondensedSkuAttributesComponent,
    {
        item: graphql`
            fragment PdpSharedCondensedSkuAttributes_item on Item {
                ...SwatchSelectorMinimal_item
                isMultiSku
                isRingItem
                skus {
                    serviceId
                    variableAttributeRows {
                        label
                        value
                    }
                }
            }
        `,
    }
);
